import { items } from '../LegalArea/data'

const content = {
  description_start:
    'Ich möchte den HSE-Newsletter abonnieren und aktuelle Trends, Angebote & Gutscheine per E-Mail erhalten. Als Dankeschön bekommen Sie einen ',
  description_end: ' Gutschein. Eine Abmeldung ist jederzeit in den Newsletter-E-Mails möglich.',
  invalid: 'Bitte prüfen Sie Ihre E-Mail.',
  fail: 'Da hat etwas nicht geklappt. Bitte versuchen Sie es später noch einmal.',
  success:
    'Wir haben eine Nachricht an Ihre E-Mail-Adresse gesendet. Bitte bestätigten Sie die Anmeldung, indem Sie auf den Button in der E-Mail klicken.',
  dataProtection: {
    ...items[1],
  },
}

export { content }
